import * as actions from "./actionTypes";
import * as config from "config";
import ObjectToQueryString from 'utils/ObjectToQueryString';
import encodeUrl from 'utils/createEncodedUrlParamsFromObject';


export function saveCableCsvData(payload){
    return {
        type: actions.SAVE_CABLE_CSV_DATA,
        payload,
    }
}

export function resetParsedCsvProps(){
    return {
        type: actions.RESET_PARSED_CSV_PROPS,
    }
}

export function parseCsvFile(payload){
    let endpointUrl = config.apiParseCsvFile;
    
    if(payload?.useCustomUrl === true) {
        endpointUrl = config.apiParseCableFile
    }
    
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: endpointUrl,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: payload?.file,
            onStart: actions.PARSE_CSV_FILE_START,
            onSuccess: actions.PARSE_CSV_FILE_DONE,
            onError: actions.PARSE_CSV_FILE_FAILED,
        },
    }
}

export function getCableTransactions(payload){
    
    let endpointUrl = config.apiGetCablePurchaseTransactions
    if(Object.keys(payload).length > 3) {
        endpointUrl = config.apiSearchFilterCablePurchaseTransactions
    }
    
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: endpointUrl + ObjectToQueryString(payload),
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "get",
            data: {},
            onStart: actions.GET_CABLE_TRANSACTIONS_START,
            onSuccess: actions.GET_CABLE_TRANSACTIONS_DONE,
            onError: actions.GET_CABLE_TRANSACTIONS_FAILED,
        },
    }
}

export function savePowerCsvData(payload){
    return {
        type: actions.SAVE_POWER_CSV_DATA,
        payload,
    }
}

export function savePowerPreviewItems(payload){
    return {
        type: actions.SAVE_POWER_PREVIEW_ITEMS,
        payload,
    }
}

export function clearPowerPreviewItems(){
    return {
        type: actions.CLEAR_POWER_PREVIEW_ITEMS,
    }
}

export function saveDataSubCsvErrors(payload){
    return {
        type: actions.SAVE_DATASUB_CSV_ERRORS,
        payload,
    }
}

export function saveDataSubCsvData(payload){
    return {
        type: actions.SAVE_DATASUB_CSV_DATA,
        payload,
    }
}

export function getPowerPurchaseTransactions(payload){
    
    let endpointUrl = config.apiGetPowerPurchaseTransactions
    
    if(Object.keys(payload).length > 3) {
        endpointUrl = config.apiSearchFilterPowerTransactions;
    }
    
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: endpointUrl + ObjectToQueryString(payload),
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "get",
            data: {},
            onStart: actions.GET_POWER_TRANSACTIONS_START,
            onSuccess: actions.GET_POWER_TRANSACTIONS_DONE,
            onError: actions.GET_POWER_TRANSACTIONS_FAILED,
        },
    }
}

export function getDataSubTransactions(payload){
    
    let endpointUrl = config.apiGetDataSubTransactions
    
    if(Object.keys(payload)?.length > 3) {
        endpointUrl = config.apiSearchFilterDataSubTransactions;
    }
    
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: endpointUrl + ObjectToQueryString(payload),
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "get",
            data: {},
            onStart: actions.GET_DATASUB_TRANSACTIONS_START,
            onSuccess: actions.GET_DATASUB_TRANSACTIONS_DONE,
            onError: actions.GET_DATASUB_TRANSACTIONS_FAILED,
        },
    }
}

export function saveAirtimeCsvErrors(payload){
    return {
        type: actions.SAVE_AIRTIME_CSV_ERRORS,
        payload,
    }
}

export function saveAirtimeCsvData(payload){
    return {
        type: actions.SAVE_AIRTIME_CSV_DATA,
        payload,
    }
}

export function saveAirtimePreviewItems(payload){
    return {
        type: actions.SAVE_AIRTIME_PREVIEW_ITEMS,
        payload,
    }
}

export function clearAirtimePreviewItems(){
    return {
        type: actions.CLEAR_AIRTIME_PREVIEW_ITEMS,
    }
}

export function getAirtimeTransactions(payload){
    
    let endpointUrl = config.apiGetAirtimeTransactions
    if(Object.keys(payload)?.length > 3) {
        endpointUrl = config.apiSearchFilterAirtimeTransactions
    }
    
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: endpointUrl + ObjectToQueryString(payload),
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "get",
            data: {},
            onStart: actions.GET_AIRTIME_TRANSACTIONS_START,
            onSuccess: actions.GET_AIRTIME_TRANSACTIONS_DONE,
            onError: actions.GET_AIRTIME_TRANSACTIONS_FAILED,
        },
    }
}

export function getProviders(){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiGetBillPaymentProviders,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "get",
            data: {},
            onStart: actions.GET_PROVIDERS_START,
            onSuccess: actions.GET_PROVIDERS,
            onError: actions.GET_PROVIDERS_FAILED,
        },
    }
}

export function airtimePurchaseSingle(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiAirtimePurchaseSingle,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.AIRTIME_PURCHASE_START,
            onSuccess: actions.AIRTIME_PURCHASE,
            onError: actions.AIRTIME_PURCHASE_FAILED,
            useEncryption: true,
        },
    }
}

export function airtimePurchaseMultiple(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiAirtimePurchaseMultiple,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.AIRTIME_PURCHASE_START,
            onSuccess: actions.AIRTIME_PURCHASE,
            onError: actions.AIRTIME_PURCHASE_FAILED,
            useEncryption: true,
        },
    }
}

export function airtimePurchaseUpload(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiAirtimePurchaseUpload,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.AIRTIME_PURCHASE_START,
            onSuccess: actions.AIRTIME_PURCHASE_UPLOAD,
            onError: actions.AIRTIME_PURCHASE_UPLOAD_FAILED,
        },
    }
}

export function getBulkAirtimeStatus(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: `${config.apiGetBulkAirtimeStatus}/${params.userId}/${params?.jobId}`,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "get",
            data: params,
            onStart: actions.GET_BULK_AIRTIME_STATUS_START,
            onSuccess: actions.GET_BULK_AIRTIME_STATUS_DONE,
            onError: actions.GET_BULK_AIRTIME_STATUS_FAILED,
        },
    }
}

export function airtimePurchaseReset(){
    return {
        type: actions.AIRTIME_PURCHASE_RESET,
        payload: {},
    }
}

export function getDataBundles(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiGetDataBundles,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.GET_DATA_BUNDLES_START,
            onSuccess: actions.GET_DATA_BUNDLES,
            onError: actions.GET_DATA_BUNDLES_FAILED,
        },
    }
}

export function dataPurchaseSingle(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiDataPurchaseSingle,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.DATA_PURCHASE_START,
            onSuccess: actions.DATA_PURCHASE,
            onError: actions.DATA_PURCHASE_FAILED,
            useEncryption: true,
        },
    }
}

export function dataPurchaseMultiple(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiDataPurchaseMultiple,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.DATA_PURCHASE_START,
            onSuccess: actions.DATA_PURCHASE,
            onError: actions.DATA_PURCHASE_FAILED,
            useEncryption: true,
        },
    }
}

export function dataPurchaseUpload(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiDataPurchaseUpload,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.DATA_PURCHASE_START,
            onSuccess: actions.DATA_PURCHASE_UPLOAD,
            onError: actions.DATA_PURCHASE_UPLOAD_FAILED,
        },
    }
}

export function dataPurchaseReset(){
    return {
        type: actions.DATA_PURCHASE_RESET,
        payload: {},
    }
}


export function electricityPurchaseValidation(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiGetElectricityValidation,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.GET_ELECTRICITY_VALIDATION_START,
            onSuccess: actions.GET_ELECTRICITY_VALIDATION,
            onError: actions.GET_ELECTRICITY_VALIDATION_FAILED,
        },
    }
}


export function electricityValidationReset(){
    return {
        type: actions.RESET_ELECTRICITY_VALIDATION,
        payload: {},
    }
}

export function electricityPurchaseSingle(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiElectricityPurchaseSingle,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.ELECTRICITY_PURCHASE_START,
            onSuccess: actions.ELECTRICITY_PURCHASE,
            onError: actions.ELECTRICITY_PURCHASE_FAILED,
            useEncryption: true,
        },
    }
}

export function electricityPurchaseMultiple(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiElectricityPurchaseMultiple,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.ELECTRICITY_PURCHASE_START,
            onSuccess: actions.ELECTRICITY_PURCHASE,
            onError: actions.ELECTRICITY_PURCHASE_FAILED,
            useEncryption: true,
        },
    }
}

export function electricityPurchaseReset(){
    return {
        type: actions.ELECTRICITY_PURCHASE_RESET,
        payload: {},
    }
}

export function getCableTvBouquets(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiGetCableTvBouquets,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.GET_CABLETV_BOUQUETS_START,
            onSuccess: actions.GET_CABLETV_BOUQUETS,
            onError: actions.GET_CABLETV_BOUQUETS_FAILED,
        },
    }
}

export function cableTvPurchaseValidation(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiGetCableTvValidation,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.GET_CABLETV_VALIDATION_START,
            onSuccess: actions.GET_CABLETV_VALIDATION,
            onError: actions.GET_CABLETV_VALIDATION_FAILED,
        },
    }
}



export function cableTvValidationReset(){
    return {
        type: actions.RESET_CABLETV_VALIDATION,
        payload: {},
    }
}

export function cableTvPurchaseSingle(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiCableTvPurchaseSingle,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.CABLETV_PURCHASE_START,
            onSuccess: actions.CABLETV_PURCHASE,
            onError: actions.CABLETV_PURCHASE_FAILED,
            useEncryption: true,
        },
    }
}

export function cableTvPurchaseMultiple(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiCableTvPurchaseMultiple,
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "post",
            data: params,
            onStart: actions.CABLETV_PURCHASE_START,
            onSuccess: actions.CABLETV_PURCHASE,
            onError: actions.CABLETV_PURCHASE_FAILED,
            useEncryption: true,
        },
    }
}

export function cableTvPurchaseReset(){
    return {
        type: actions.CABLETV_PURCHASE_RESET,
        payload: {},
    }
}

export function getBeneficiaries(params){
    const encodedUrl = encodeUrl(params);
    
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiGetBillPaymentBeneficiaries + encodedUrl,
            method: "get",
            data: {},
            onStart: actions.GET_BENEFICIARIES_START,
            onSuccess: actions.GET_BENEFICIARIES,
            onError: actions.GET_BENEFICIARIES_FAILED,
        },
    }
}

export function getAllBeneficiaries(params){
    const encodedUrl = encodeUrl(params);
    
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiBillPaymentBaseUrl,
            url: config.apiGetBillPaymentBeneficiaries + encodedUrl,
            // url: config.apiGetBillPaymentBeneficiaries + ObjectToQueryString(params),
            additionalHeaders: {"Authorization": config.apiBillPaymentToken},
            method: "get",
            data: {},
            onStart: actions.GET_ALL_BENEFICIARIES_START,
            onSuccess: actions.GET_ALL_BENEFICIARIES,
            onError: actions.GET_ALL_BENEFICIARIES_FAILED,
        },
    }
}

export function createBeneficiary(params) {
  return {
    type: config.apiRequestStart,
    payload: {
      baseUrl: config.apiBillPaymentBaseUrl,
      url: config.apiCreateBeneficiary,
      additionalHeaders: { Authorization: config.apiBillPaymentToken },
      method: 'post',
      data: params,
      onStart: actions.CREATE_BENEFICIARY_START,
      onSuccess: actions.CREATE_BENEFICIARY,
      onError: actions.CREATE_BENEFICIARY_FAILED,
      useEncryption: true,
    },
  };
}

export function editBeneficiary(params, id) {
  return {
    type: config.apiRequestStart,
    payload: {
      baseUrl: config.apiBillPaymentBaseUrl,
      url: config.apiEditBeneficiary + id,
      additionalHeaders: { Authorization: config.apiBillPaymentToken },
      method: 'put',
      data: params,
      onStart: actions.EDIT_BENEFICIARY_START,
      onSuccess: actions.EDIT_BENEFICIARY,
      onError: actions.EDIT_BENEFICIARY_FAILED,
      useEncryption: true,
    },
  };
}

export function deleteBeneficiary(id) {
  return {
    type: config.apiRequestStart,
    payload: {
      baseUrl: config.apiBillPaymentBaseUrl,
      url: config.apiDeleteBeneficiary + id,
      additionalHeaders: { Authorization: config.apiBillPaymentToken },
      method: 'delete',
      data: {},
      onStart: actions.DELETE_BENEFICIARY_START,
      onSuccess: actions.DELETE_BENEFICIARY,
      onError: actions.DELETE_BENEFICIARY_FAILED,
    },
  };
}
